import { render, staticRenderFns } from "./CustomerSaveFormPhysical.vue?vue&type=template&id=26fe6814"
import script from "./CustomerSaveFormPhysical.vue?vue&type=script&lang=js"
export * from "./CustomerSaveFormPhysical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports